import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './FieldLabel.module.css';

/**
 * A field label carrying its required / optional marker.
 *
 * Sellers were hesitating because the listing form gave no signal about what
 * actually blocks publishing. Marking BOTH states is deliberate: marking only
 * the required ones leaves every unmarked field ambiguous ("is this required
 * and they forgot to mark it?"), which is the hesitation we're trying to
 * remove.
 *
 * Required-ness must come from the hosted Console listing-fields asset, since
 * that is what Sharetribe validates against at runtime — see
 * CustomExtendedDataField, which reads `saveConfig.isRequired`.
 *
 * @component
 * @param {Object} props
 * @param {React.Node} props.children - the label text
 * @param {boolean} [props.isRequired]
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
const FieldLabel = props => {
  const { children, isRequired = false, className } = props;
  return (
    <span className={classNames(css.root, className)}>
      {children}
      {isRequired ? (
        <span className={css.required} aria-hidden="true">
          *
        </span>
      ) : (
        <span className={css.optional}>
          <FormattedMessage id="EditListingForm.optionalMarker" />
        </span>
      )}
    </span>
  );
};

export default FieldLabel;
